import { jsx as _jsx } from "react/jsx-runtime";
import MuiDialog from '@material-ui/core/Dialog';
import { alpha, withStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { forwardRef } from 'react';
import palette from '../palette';
const Dialog = withStyles(theme => ({
  backdropSecondary: {
    background: alpha(palette.INDIGO, 0.7)
  },
  backdropDefault: {
    background: alpha(palette.INK, 0.7)
  },
  paper: {
    boxShadow: theme.shadows[3],
    borderRadius: theme.shape.borderRadius * 4
  },
  paperFullScreen: {
    borderRadius: 0
  },
  content: {
    paddingBottom: theme.spacing(4)
  },
  paperWidthMd: {
    maxWidth: 880
  }
}))(forwardRef(({
  classes,
  color = 'secondary',
  ...props
}, ref) => _jsx(MuiDialog, {
  classes: {
    paper: classes.paper,
    paperFullScreen: classes.paperFullScreen,
    paperWidthMd: classes.paperWidthMd
  },
  BackdropProps: {
    classes: {
      root: clsx({
        [classes.backdropSecondary]: color === 'secondary',
        [classes.backdropDefault]: color === 'default'
      })
    }
  },
  ...props,
  ...{
    ref
  }
})));
export default Dialog;